var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSponsorLogoPason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 80",
    style: {
      enableBackground: "new 0 0 216 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E87200;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#004E59;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.9,4.8c-17.4,0-33.7,1.4-48.2,3.9c11.1-1.5,23.2-2.3,35.8-2.3c54,0,97.7,14.6,97.7,32.5 c0,18-43.8,32.5-97.7,32.5c-24.3,0-46.5-2.9-63.6-7.8c19.1,6.7,46,10.8,75.9,10.8c57.9,0,104.8-15.6,104.8-34.9 C211.7,20.4,164.8,4.8,106.9,4.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.2,42.5c-1.8,3.6,0.4,4.4,4.5,4.3h4.6c3.4,0,4.2-0.3,6.9-2l-0.9,1.7h6.4l5-10c1.8-3.6,0.3-5.5-4.3-5.5h-7.8 c-5.7,0-8.4,0.7-10.5,4.8h6.5c0.6-1.1,1.2-1.2,3.2-1.2h4c2.6,0,2.9,0.5,2.1,2l-0.7,1.3c-0.7-1.1-2.7-1.2-6.4-1.2 c-6.5,0-10,0.2-12.1,4.4L43.2,42.5z M52.8,43.3c-2.6,0-3.3-0.4-2.8-1.4c0.6-1.3,1.5-1.8,4.3-1.8h3c3.7,0,3.9,0.4,3.3,1.6 c-0.5,1-1.2,1.6-5.9,1.6C54.7,43.3,52.8,43.3,52.8,43.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78,41.9c-0.4,0.8-0.4,1.4,3.5,1.4h2.4c3.2,0,4.1-0.2,4.6-1.1s0.1-1.3-2.3-1.3h-6.3c-6.2,0-7.5-1.2-5.4-5.4 c1.9-3.8,5.8-4.4,10.4-4.4h4.7c8.8,0,9.8,1,8.1,4.6H91c0.1-0.9-0.5-1-4.5-1c-3.9,0-4.7,0.1-5.2,1.1c-0.3,0.7,0.1,0.9,3.6,0.9h4.7 c8,0,7.5,2.3,6.1,5c-2,4-4.4,5.1-12.1,5.1H77c-6.2,0-7.8-1.2-5.9-5H78V41.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.8,40.8c-2.5,5,0.9,6,4.3,6h10c3.4,0,7.9-1,10.4-6l1.8-3.6c2.5-5-0.9-6-4.3-6h-10c-3.4,0-7.9,1-10.4,6 L99.8,40.8z M107.8,38.3c1.1-2.2,2.9-2.8,6-2.8h1.6c4.3,0,4.9,0.5,3.9,2.5l-1.1,2.1c-1,2-2.1,2.5-6.4,2.5h-1.6 c-3.1,0-4.3-0.7-3.2-2.8L107.8,38.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.9,31.3h6.7l-1.3,2.6h0.1c2.3-2.1,4.9-2.7,8.5-2.7c4.2,0,9.9,0.1,6.6,6.7l-4.4,8.8h-6.7l4.4-8.8 c0.7-1.5-0.3-2.2-3.2-2.2h-1.5c-2.9,0-5.2,1.1-6.3,3.3l-3.9,7.7h-6.7L133.9,31.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.9,58.7H11L18.4,44h0.1c0.5,2.5,1.8,2.9,6,2.9H26c9.5,0,12-2.6,13.9-6.6l1.4-2.8c1.9-3.9,2-6.6-7.5-6.6h-2.2 c-4.4,0-6.4,1.2-8,2.5h-0.1l1.1-2.3h-8.1L2.9,58.7z M21.2,38.2c1.1-2.3,3-2.8,5.9-2.8h4c3.6,0,3.5,1,2.6,2.7l-0.9,1.8 c-0.8,1.7-1.7,2.7-5.3,2.7h-4c-3,0-4.3-0.5-3.2-2.8L21.2,38.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsorLogoPason);
export default __webpack_public_path__ + "static/media/sponsor-logo-pason.018e4382a3404e0a318d48d2e1c2e8c5.svg";
export { ForwardRef as ReactComponent };